import { useEffect } from "react";
import Map from "./Map";
import Pagination from "./Pagination";
import Header from "../common/header/DefaultHeader";
import MobileMenu from "../common/header/MobileMenu";
import FilterTopBar2 from "./FilterTopBar2";
import GridListButton from "./GridListButton";
import ShowFilter from "./ShowFilter";
import PopupSignInUp from "../common/PopupSignInUp";
import FeaturedItem from "./FeaturedItem";
import { useDispatch, useSelector } from "react-redux";
// import Loader from "../common/loader/Loader";
import { ShimmerPostItem, ShimmerPostList } from "react-shimmer-effects";
import "./CardComponents/SRPCard.css";
import FilterBar from "./FilterBar";
import { checkLoginStatus } from "@/api/myProfile";
import { encrypt } from "@/utils/crypto";
import { processVisitor } from "@/api/home";
import SidebarModal from "./SidebarModal";
import { trackApiCall } from "@/utils/analytics";
// import SrpFooter from "./SrpFooter";
import useWindowDimensions from "@/hooks/useWindowDimensions";
import { toggleGridAndList } from "@/features/filter/filterSlice";
import NewFooter from "../common/footer/NewFooter";
import OtherLinkFooter from "../common/footer/OtherLinkFooter";
import { generatePropertyListSchema, injectSchema, removeSchema } from "@/utils/schema";


const index = ({ pageNumber, setPageNumber, srpCmsData }) => {
  const isSRPLoading = useSelector((state) => state.srp.isSRPLoading);
  const isGridOrList = useSelector((state) => state.filter.isGridOrList);
  const properties = useSelector((state) => state.srp.srpInitData?.srpTupples);
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();
  const gooleMapKey = srpCmsData?.googleMapApiKey;

  const trackSRPEvent = (eventName, eventParams = {}) => {
    trackApiCall({
      eventName,
      eventSource: "Map Interaction",
      eventCategory: "NEW-SRP",
      eventParams,
    });
  };

  useEffect(() => {
    if (width < 991) {
      dispatch(toggleGridAndList(false));
    }
  }, [width])

  // Inject schema for SEO (top 5 properties only for performance)
  useEffect(() => {
    // console.log('SRP Schema Effect - Properties:', properties?.length);
    if (properties && properties.length > 0) {
      const topProperties = properties.slice(0, 5);
      // console.log('Top 5 Properties:', topProperties);
      const schema = generatePropertyListSchema(topProperties);
      // console.log('Generated Schema:', schema);
      if (schema) {
        injectSchema(schema, 'srp-schema');
        // console.log('Schema injected with id: srp-schema');
      }
    }
    return () => {
      // console.log('Removing srp-schema');
      removeSchema('srp-schema');
    };
  }, [properties]);

  useEffect(() => {
    let isMounted = true;

    const initializeData = async () => {
      try {
        const loginResponse = await checkLoginStatus();
        const userEmailId = loginResponse?.userEmailId;
        const userId = loginResponse?.realbidUserId;

        if (!isMounted) return;

        const redisPayload = new FormData();
        if (userEmailId) {
          const encryptedEmail = await encrypt(userEmailId);
          redisPayload.append("emailAddr", encryptedEmail);
        }

        await Promise.all([
          processVisitor(),
          //getExperiments("onLogin", userId),

        ]);
      } catch (error) {
        console.error("Error initializing data:", error);
        trackSRPEvent("srp_view_error", { error_message: error?.message });
      }
    };

    initializeData();

    // Cleanup function
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <main>
      <Header />
      <MobileMenu />
      <PopupSignInUp />

      {/* <!-- Listing Grid View --> */}
      <section
        id="feature-property"
        className="our-listing our-listing_map2 srp-container"
      >
        {/* Filter bar on web */}
        {width >= 991 && <div className="col-md-12 pos-fixed">
          <div className="grid_list_search_result border-zero pt0 pb0" tabIndex="0" aria-label="Search filters and view options">
            <div className="row align-items-center pl25 pr25">
              <div className="listing_list_style text-align-left m0" tabIndex="0">
                <FilterBar />
              </div>
              <div className="text-align-right listing_list_style m0 grid-button-container" tabIndex="0">
                <GridListButton pageNumber={pageNumber} />
              </div>
            </div>
          </div>
        </div>}
        {/* Filter bar on Mobile */}
        {width < 991 && (
          <>
            <div className="fixed-mob-header">
            </div>
              <ShowFilter />
            <div className='row pl25 pr35 pb15 pt15 align-items-end'>
              <FilterTopBar2 pageNumber={pageNumber} isMobView={true} />
            </div>
          </>
        )}

        <div className="container-fluid">
          {/* sidebar switch */}
          <SidebarModal FilterBar={FilterBar} />

          <div className="row p0">
            {/* Listing Section */}
            <div
              className={`${
                isGridOrList ? "list-container order-lg-2 order-xl-1" : ""
              } p0`}
            >
              <div className={isGridOrList ? "dn-pt20" : "dn-pt20"}>
                <div
                  className={`col-md-12 ${
                    width < 991 ? 'pr5 pl5' : isGridOrList ? "pl25 pr15" : "pl15 pr15"
                  }`}
                >
                  {width > 991 && (
                    <div
                      className={`${
                        isGridOrList ? "pl15" : "pl25 pr25"
                      } row pb15`}
                    >
                      <FilterTopBar2 pageNumber={pageNumber} />
                    </div>
                  )}
                  {/* {isSRPLoading && (
                      <Loader />
                  )} */}
                  {isSRPLoading && (
                    <div
                      className={`row ${
                        isGridOrList ? "pl10 pr0" : "pl15 pr15"
                      }`}
                    >
                      {isGridOrList ? (
                        <div>
                          {[...Array(8)].map((_, index) => (
                            <div key={index} style={{ marginBottom: '20px' }}>
                              <ShimmerPostItem
                                card
                                title
                                cta
                                imageType="thumbnail"
                                imageWidth={200}
                                imageHeight={40}
                              />
                            </div>
                          ))}
                        </div>
                      ) : (
                        <ShimmerPostList
                          postStyle="STYLE_FOUR"
                          col={4}
                          row={24}
                          gap={30}
                        />
                      )}
                    </div>
                  )}
                  <div className={`row ${isGridOrList ? "pl10" : "pl10 pr10 justify-content-center"}`}>
                    {!isSRPLoading && <FeaturedItem />}
                  </div>

                  <div className="mbp_pagination mt10" tabIndex="0">
                    {!isSRPLoading && (
                      <Pagination
                        pageNumber={pageNumber}
                        setPageNumber={setPageNumber}
                      />
                    )}
                  </div>
                </div>
                {/* Footer */}

                      <OtherLinkFooter/>
                      <div className="container-fluid main_footer px-0">
                      <NewFooter isMapOpen={isGridOrList}/>

                      </div>
              </div>
            </div>
            {/* Map section */}
            {isGridOrList ? (
              <div className="order-lg-1 order-xl-2 map-container">
                <div className="home_two_map style2 half_map_area">
                  <div className="gmap_canvas map-canvas half_style bg-white">
                    <Map gooleMapKey={gooleMapKey}/>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </section>
    </main>
  );
};

export default index;
